import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { PRESETS } from './utils';

export function DriverFilters({ preset, onPreset, range, onRange, customers, selectedCustomers, onToggleCustomer, firms, firmId, onFirm, showFirm }) {
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 space-y-3" data-testid="driver-analytics-filters">
      <div className="flex flex-wrap items-center gap-2">
        {PRESETS.map((p) => (
          <Button
            key={p.key}
            size="sm"
            variant={preset === p.key ? 'default' : 'outline'}
            onClick={() => onPreset(p.key)}
            data-testid={`driver-preset-${p.key}`}
          >
            {p.label}
          </Button>
        ))}
        <div className="flex items-center gap-1.5 ml-auto">
          <Input type="date" value={range.start} onChange={(e) => onRange({ ...range, start: e.target.value })} className="h-8 w-[150px]" data-testid="driver-range-start" />
          <span className="text-slate-400">—</span>
          <Input type="date" value={range.end} onChange={(e) => onRange({ ...range, end: e.target.value })} className="h-8 w-[150px]" data-testid="driver-range-end" />
        </div>
        {showFirm && (
          <Select value={firmId || 'all'} onValueChange={(v) => onFirm(v === 'all' ? '' : v)}>
            <SelectTrigger className="h-8 w-[180px]" data-testid="driver-firm-select"><SelectValue placeholder="Tüm firmalar" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tüm firmalar</SelectItem>
              {firms.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-xs text-slate-500 mr-1">Müşteri:</span>
        {customers.map((c) => {
          const on = selectedCustomers.includes(c.slug);
          return (
            <button
              key={c.slug}
              type="button"
              onClick={() => onToggleCustomer(c.slug)}
              className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${on ? 'bg-slate-900 text-white border-slate-900 dark:bg-white dark:text-slate-900' : 'border-slate-200 text-slate-600 hover:border-slate-400 dark:border-slate-700 dark:text-slate-300'}`}
              data-testid={`driver-customer-${c.slug}`}
            >
              {c.name}
            </button>
          );
        })}
        {selectedCustomers.length === 0 && <span className="text-[11px] text-slate-400">(hepsi)</span>}
      </div>
    </div>
  );
}
